var option_webview_default = {
  "option": "NnF3z",
  "user_choice": "kmWPC",
  "check": "D7Ibs",
  "image": "FMTQU",
  "input": "XrgkW",
  "title": "WgjLB",
  "centered": "_0SXFp",
  "with_result": "OGAv-",
  "list": "xUGlF",
  "with_image": "F8zUt",
  "progress": "lYPZe",
  "progress_value": "IEGIg",
  "label": "Jn2GX",
  "cta": "Ipx0w",
  "adornment_icon": "dhXAl",
  "remove": "bntA3",
  "removeButton": "goUgb",
  "removeButtonIcon": "gYGui",
  "overlay": "uSrKy",
  "shown": "Zpuuk",
  "dark": "uK33W",
  "spinner": "VWgX-",
  "spin": "Nf4la",
  "grid": "hcN0Y"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
